// Coinhouse brand tokens (design brief: neutral base, colour concentrated in the signature gradient).

export const brand = {
  cyan: '#03ffcf',
  cyanBright: '#00ffff',
  blue: '#4141ff',
  purple: '#8700ff',
  pink: '#ff00aa',
  red: '#ff4b28',
  green: '#00bb97',

  ink: '#171717',
  page: '#e9eef2',
  surface: '#ffffff',
  surfaceMuted: '#f4f6f8',
  border: '#c2cad2',
  borderSoft: '#dde3e8',
  muted: '#8e98a3',
  // #8e98a3 is below AA for body text on white; secondary text uses this darker grey.
  textSecondary: '#5b6570',
  tintViolet: '#f5f0ff'
};

export const brandGradients = {
  button:
    'linear-gradient(71.67deg,#03ffcf -113.8%,#0ff -71.51%,#4141ff -29.23%,#8700ff 13.06%,#f0a 55.34%,#ff4b28 97.63%)',
  blue: 'linear-gradient(253.05deg,#03ffcf 9.96%,#0ff 50.95%,#4141ff 94.04%,#8700ff 136.08%,#f0a 178.13%,#ff4b28 220.17%)',
  purple: 'linear-gradient(95.83deg,#8700ff 10.04%,#f0a 100.77%)',
  orange: 'linear-gradient(95.83deg,#f0a 10.04%,#ff4b28 92.45%)',
  business: 'linear-gradient(90deg,#4141ff,#0ff 28%,#03ffcf 60%,#00bb97 96.5%)',
  // Dark enough to carry a white icon.
  green: 'linear-gradient(95deg,#00806a 0%,#00bb97 100%)',
  // Vertical accent bar for the active navigation item.
  accentBar: 'linear-gradient(180deg,#4141ff 0%,#8700ff 45%,#f0a 75%,#ff4b28 100%)'
};

// Status badge tones: a light tint, AA-contrast text and a vivid dot per state.
export const statusTones = {
  success: { bg: '#e6f5f1', text: '#006650', dot: '#00bb97' },
  info: { bg: '#f5f0ff', text: '#5a00b3', dot: '#8700ff' },
  warning: { bg: '#fff3dd', text: '#8a4b00', dot: '#f59e0b' },
  error: { bg: '#fdeeea', text: '#b0280b', dot: '#ff4b28' },
  secondary: { bg: '#eef1f4', text: '#4a5560', dot: '#8e98a3' },
  primary: { bg: '#ededff', text: '#2b2bd1', dot: '#4141ff' },
  black: { bg: '#171717', text: '#ffffff', dot: '#ffffff' }
};

export const brandFonts = {
  heading: '"Sora", ui-sans-serif, system-ui, sans-serif',
  body: '"dm-sans", "DM Sans", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: 'ui-monospace, "SF Mono", Menlo, Monaco, Consolas, monospace'
};

// Keyword highlight: gradient clipped to text, used on a few words of a heading only.
export const gradientText = {
  background: brandGradients.purple,
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  color: 'transparent',
  WebkitTextFillColor: 'transparent'
} as const;

// Same highlight for dark surfaces: lifted purple keeps large text above 3:1 on #171717.
export const gradientTextOnDark = {
  ...gradientText,
  background: 'linear-gradient(95.83deg,#a54dff 10.04%,#f0a 100.77%)'
} as const;
